import React, { useEffect } from "react";
import withContext from "../../utils/withContext";

export const AdFoxAdaptive = ({ options, context, cls = true, className = "adfox" }) => {
    useEffect(() => {
        const opts = [...options];
        opts[0].params["partner-stat-id"] = context.uniq_id;
        window.yaContextCb.push(() => {
            window.Ya.adfoxCode.create(...opts);
        });
    }, [options, context.uniq_id]);

    return <div id={options[0].containerId} {...(cls ? { className: className } : {})} />;
};

export default withContext(AdFoxAdaptive);
